import {StoreType} from '../../../types/sharedTypes';

export const storeParamsSelector = (state: StoreType) => {
  return state.storeReducer.params;
}

export const allStoresSelector = (state: StoreType) => {
  return state.storeReducer.storesResult;
}
